namespace ui
{
	export namespace table
	{

		export abstract class DataReader<T>
		{

			protected m_Data: T[];

			public Data( data?: T[] ): T[]|void
			{
				if ( data )
				{
					this.m_Data = data;

					return;
				}

				return this.m_Data;
			}

			public AddData( data: T ): void
			{
				this.m_Data.push( data );
			}

			public InsertData( row: number, data: T ): void
			{
				this.m_Data.splice( row, 0, data );
			}

			public abstract GenerateDataField( p_Data: T, index: number ): JQuery;

			public GenerateDatafields(): JQuery[]
			{
				const data = new Array<JQuery>();

				this.m_Data.forEach(
					( list: T, index: number ) =>
					{
						data.push( this.GenerateDataField( list, index ) );
					},
				);

				return data;
			}

			protected constructor()
			{
				this.m_Data = new Array<T>();
			}

		}

	}
}
